// src/components/StatusBadge.js
import React from 'react';

function StatusBadge({ status, label }) {
  const normalized = (status || '').toLowerCase();
  let variant = 'warning';
  if (normalized === 'ok' || normalized === 'active' || normalized === 'trialing') variant = 'success';
  if (normalized === 'not found' || normalized === 'error' || normalized === 'failed' || normalized === 'canceled' || normalized === 'unpaid') variant = 'error';

  return (
    <span className={`badge badge--${variant}`} aria-label={`${label}: ${status}`} title={`${label}: ${status}`}>
      <span className="badge-dot" />
      <span>{label}</span>
    </span>
  );
}

export default StatusBadge;

